{
  "main": {
    "title": "Club Directory",
    "nazaj": "Back"
  },
  "navs": {
    "vnos": "Add",
    "seznam": "List"
  },
  "table": {
    "sifra": "Code",
    "naziv": "Name",
    "naslov": "Address",
    "podrobno": "Details"
  },
  "modal": {
    "sifra": "Code:",
    "naziv": "Name:",
    "naslov": "Address:",
    "posta": "Postal Code:",
    "kraj": "City:",
    "email": "Email:",
    "telefon": "Phone:"
  },
  "buttons": {
    "csv": "Export to CSV",
    "uredi": "Edit data",
    "posodobi": "Update data",
    "brisi": "Delete club"
  }
}